import { Component, OnInit } from '@angular/core';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { EmrListComponent } from "../../../../shared/emr-list/emr-list.component";
import { RespiratoryAssessment } from 'src/app/calvin-emr-shared/models/assessments/respiratory.model';

@Component({
  selector: 'app-respiratory-info',
  templateUrl: './respiratory-info.component.html',
  styleUrls: ['./respiratory-info.component.scss'],
  standalone: true,
  imports: [
    AssessmentRowComponent,
    EmrListComponent
  ],
})
export class RespiratoryInfoComponent
  extends AssessmentInfoComponent<RespiratoryAssessment>
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void { }

  get isRegularRhythm() {
    return !this.data.irregularRhythm ? 'Yes' : 'No';
  }

  get isCoughPresent() {
    return this.data.cough ? 'Yes' : 'No';
  }
  get isUnableToAssess() {
    return this.data.abilityToAssess ? 'Yes' : 'No';
  }

  get isProductiveCough() {
    return this.data.coughDescription.toLocaleLowerCase() === 'productive';
  }

  get isTrachPresent() {
    return this.data.trachPresent ? 'Yes' : 'No';
  }
}
